import React from "react";
import styles from "./sharePreview.module.css";
import { useLocation } from "react-router-dom";
import Button from "common/Button";

const ShareEventPreview = ({setModalIsOpen}) => {
  const location = useLocation();

  const currentUrl =
    window.location.origin +
    location.pathname +
    location.search +
    location.hash;

 
  return (
      <div className={styles.ModalInfo}>
        <div className={styles.label}>Share your event</div>
        <div className={styles.subLabel}>
          Share your event with your networks
        </div>
        <div className={styles.link_}>{currentUrl}</div>
        <div className={styles.horizontalLine}>
          <Button
            label={"Close"}
            buttonOverrideStyle={styles.buttonOverrideStyle}
            onClick={() => setModalIsOpen(false)}
          ></Button>
      </div>
      </div>
  );
};

export default ShareEventPreview;
